import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { EmailLogProvider } from "../contexts/EmailLogContext";
import { DialogProvider } from "../contexts/DialogContext";

export const EmailLogComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[<EmailLogProvider key={0} />, <DialogProvider key={1} />]}
    >
      {children}
    </ContextProviderComposer>
  );
};

export default EmailLogComposer;
